import React from 'react';
import { Box, Typography, Paper, Divider, Container } from '@mui/material';
import { 
  Info, 
  Psychology, 
  Visibility, 
  Work, 
  Star, 
  Favorite, 
  AutoStories,
  CheckCircle 
} from '@mui/icons-material';

export default function AboutUs() {
  return (
    <Box sx={{ 
      minHeight: '100vh', 
      background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
      py: 4
    }}>
      <Container maxWidth="md">
        <Paper elevation={8} sx={{ 
          p: { xs: 3, md: 6 }, 
          borderRadius: 3,
          background: 'rgba(255, 255, 255, 0.95)',
          backdropFilter: 'blur(10px)'
        }}>
          {/* Header */}
          <Box sx={{ textAlign: 'center', mb: 4 }}>
            <Info sx={{ fontSize: 48, color: '#FF7043', mb: 2 }} />
            <Typography variant="h3" gutterBottom sx={{ 
              color: '#2c3e50', 
              fontWeight: 700,
              fontSize: { xs: '2rem', md: '2.5rem' }
            }}>
              About <strong>Ascend Yantra</strong> Meditation
            </Typography>
            <Typography variant="h6" sx={{ color: '#7f8c8d', fontWeight: 400, mb: 2 }}>
              A minimalist and meaningful meditation experience
            </Typography>
            <Typography variant="body1" sx={{ 
              color: '#34495e', 
              lineHeight: 1.7,
              fontSize: '1.1rem',
              maxWidth: 600,
              mx: 'auto'
            }}>
              <strong>Ascend Yantra</strong> Meditation is a minimalist and meaningful meditation app that helps you quiet the mind, focus your attention, and connect with your inner stillness — all through the ancient power of Yantras.
            </Typography>
          </Box>

          <Divider sx={{ mb: 4 }} />

          {/* Introduction */}
          <Box sx={{ mb: 4 }}>
            <Typography variant="body1" sx={{ 
              color: '#34495e', 
              lineHeight: 1.7,
              fontSize: '1.1rem',
              mb: 3
            }}>
              At the heart of the app is a curated collection of sacred Yantra cards, created by <strong>Ivan Rados</strong>. Each Yantra is a powerful visual symbol rooted in centuries of spiritual tradition, designed to draw the mind into deep concentration and inner awareness.
            </Typography>
            <Typography variant="body1" sx={{ 
              color: '#34495e', 
              lineHeight: 1.7,
              fontSize: '1.1rem'
            }}>
              Whether you're new to meditation or seeking a simple, screen-free way to center yourself, <strong>Ascend Yantra Meditation offers a focused and clutter-free experience.</strong>
            </Typography>
          </Box>

          <Divider sx={{ mb: 4 }} />

          {/* What the App Offers */}
          <Box sx={{ mb: 4 }}>
            <Typography variant="h5" gutterBottom sx={{ 
              color: '#2c3e50', 
              fontWeight: 600,
              mb: 2,
              display: 'flex',
              alignItems: 'center',
              gap: 1
            }}>
              <Work sx={{ color: '#FF7043' }} />
              What the App Offers
            </Typography>
            
            <Typography variant="h6" gutterBottom sx={{ color: '#34495e', fontWeight: 600, mt: 3 }}>
              Explore the Power of Yantras
            </Typography>
            <Typography variant="body1" sx={{ color: '#34495e', mb: 3, lineHeight: 1.7 }}>
              Learn the meaning and purpose behind each Yantra. Discover how these sacred geometric patterns have been used as tools for meditation and personal transformation.
            </Typography>

            <Typography variant="h6" gutterBottom sx={{ color: '#34495e', fontWeight: 600, mt: 3 }}>
              Meditate with a Yantra
            </Typography>
            <Typography variant="body1" sx={{ color: '#34495e', mb: 3, lineHeight: 1.7 }}>
              Choose a Yantra card, play a soothing background music track, and begin your session. Simply gaze at the center of the Yantra and let your awareness settle. No guidance. No distractions. Just you and the symbol.
            </Typography>

            <Typography variant="h6" gutterBottom sx={{ color: '#34495e', fontWeight: 600, mt: 3 }}>
              Choose Your Soundtrack
            </Typography>
            <Typography variant="body1" sx={{ color: '#34495e', mb: 3, lineHeight: 1.7 }}>
              Select from calming music options to support your meditation environment and enhance your focus.
            </Typography>
          </Box>

          <Divider sx={{ mb: 4 }} />

          {/* Why Ascend Yantra */}
          <Box sx={{ mb: 4 }}>
            <Typography variant="h5" gutterBottom sx={{ 
              color: '#2c3e50', 
              fontWeight: 600,
              mb: 2,
              display: 'flex',
              alignItems: 'center',
              gap: 1
            }}>
              <Star sx={{ color: '#FF7043' }} />
              Why <strong>Ascend Yantra</strong>?
            </Typography>
            <Typography variant="body1" sx={{ 
              color: '#34495e', 
              lineHeight: 1.7,
              fontSize: '1.1rem',
              mb: 3
            }}>
              In a world of overcomplicated meditation apps, <strong>Ascend Yantra</strong> keeps things simple and intentional. There are no breathing timers, no voiceovers, and no notifications — just pure visual meditation based on the timeless practice of using Yantras as focal points.
            </Typography>
            <Typography variant="body1" sx={{ 
              color: '#34495e', 
              lineHeight: 1.7,
              fontSize: '1.1rem'
            }}>
              This experience is grounded in the creative work of <strong>Ivan Rados</strong>, whose Yantras offer a gateway to inner clarity and spiritual alignment.
            </Typography>
          </Box>

         

        </Paper>
      </Container>
    </Box>
  );
} 